import React, {useMemo} from 'react';


export function TypeBadge({type}) {
    const config = useMemo(() => {
        if (!type) return {class: 'tw-badge tw-badge-neutral', text: 'N/A'};


        const isPreExpiration = type.includes('pre_expiration');
        const isExpiration = type.includes('expiration') && !type.includes('pre');
        const isDeletion = type.includes('deletion');


        let badgeClass = 'tw-badge tw-badge-neutral';
        if (isPreExpiration) badgeClass = 'tw-badge tw-bg-amber-100 tw-text-amber-700';
        else if (isExpiration) badgeClass = 'tw-badge tw-bg-red-100 tw-text-red-700';
        else if (isDeletion) badgeClass = 'tw-badge tw-bg-slate-200 tw-text-slate-700';


        return { class: badgeClass, text: type.replace(/_/g, ' ').toUpperCase() };
    }, [type]);


    return <span className={`${config.class} tw-text-xs`}>{config.text}</span>;
}
